














































































import { Component, Prop } from 'vue-property-decorator'
import { Test, TestStatus } from '@shared/types/database'
import { User } from '@/types/frontend'
import { isCompleted } from '@/utilities/test-helpers'
import { EditProjectPayload } from '@/components/TestDetails/EditProjects.vue'
import { FollowerData } from '@/components/TestDetailsLegacy.vue'
import Followers from './Followers.vue'
import Tags from './Tags.vue'
import Projects from './Projects.vue'
import store from '@/store'
import analytics from '@/analytics'
import api from '@/api'
import * as graph from '@shared/types/graphql'
import { mixins } from 'vue-class-component'
import SetToastMessage from '@/mixins/SetToastMessage.vue'
import { PresetTestMessages } from '@/store/modules/notification-store-module'

@Component({
  components: {
    Followers,
    Tags,
    Projects
  }
})
export default class MetaHeader extends mixins(SetToastMessage) {
  @Prop({ required: true }) readonly followers!: User[]
  @Prop({ required: true }) readonly users!: User[]
  @Prop({ required: true }) readonly test!: Test
  @Prop({ required: true }) readonly livechartsEnabled!: boolean

  tagsUpdating = false
  currentTags: string[] = []

  get completed () {
    return isCompleted(this.test.payload.status)
  }

  get tags (): string[] {
    if (!this.test.payload.tags) return []
    if (this.currentTags.length) return this.currentTags

    return this.test.payload.tags.split(',')
  }

  get respondentCountText (): string | number {
    if (this.test.payload.status === TestStatus.Draft) {
      return 'N/A'
    } else {
      return this.respondentCount
    }
  }

  get creatorName (): string | null {
    if (!this.test) return null

    const creator = this.users.filter(user => user.id === this.test.created_by.id)[0]
    if (!creator) return null
    return creator.fullName
  }

  get projects () {
    return store.getters.workspace.getProjectsByTestId(this.test.id.toString())
  }

  get respondentCount () {
    if (this.livechartsEnabled) {
      return store.getters.survey.respondentCount
    } else {
      return this.test.payload.people
    }
  }

  editFollower (event: FollowerData) {
    if (event.follow) {
      this.followers.push(event.user)
    } else {
      const followerIdx = this.followers.findIndex((follower) => {
        return follower.id === event.user.id
      })
      if (followerIdx >= 0) this.followers.splice(followerIdx, 1)
    }
    this.saveFollowers(event.follow, event.user.id)
  }

  // Both adding and removing followers go through here. May want to split this into multiple routes where one is adding yourself, while the other is adding others
  // Also there's a small potential for users to be emailed multiple times being added to a single test since it relies on redis sets in MGT and we're adding/removing each user individually instead of in a batch now
  saveFollowers (follow: boolean, uid: string) {
    const userIds = this.followers.map((u) => { return u.id })
    const testTitle = this.test.payload.title ?? ''

    api.subscribeGroup(this.workspaceId, this.testId, userIds, testTitle)

    const eventName = follow ? 'Follow Test' : 'Unfollow Test'
    analytics.track(eventName, {
      testId: this.testId,
      workspaceId: this.workspaceId,
      uid: uid
    })
  }

  async editProject (data: EditProjectPayload) {
    const newIds = data.project.ids
    const updateData: graph.UpdateProjectInput = {}

    if (data.follow) {
      newIds.push(this.testId)
    } else {
      newIds.splice(newIds.findIndex((id: string) => id === this.testId), 1)
      updateData.delete = { ids: [this.testId] }
    }

    updateData.ids = newIds
    const newProject = await store.dispatch.workspace.updateProject({
      id: data.project.id,
      projectData: updateData
    })

    const failedInclusion = data.follow && !newProject?.ids.includes(this.testId)
    const failedRemoval = !data.follow && newProject?.ids.includes(this.testId)
    const successfulRemovalFromCurrentProject = !data.follow && this.project?.id === data.project.id

    if (failedInclusion || failedRemoval) {
      this.toast = PresetTestMessages.projectAssociationFail
    } else if (successfulRemovalFromCurrentProject) {
      this.$router.push(`/workspaces/${this.workspaceId}/tests/${this.testId}`)
    }
  }

  get workspaceId () {
    return this.$route.params.workspaceId
  }

  get projectId () {
    return this.$route.params.projectId
  }

  get testId () {
    return this.$route.params.testId
  }

  get project () {
    if (this.projectId) {
      return store.getters.workspace.getProjectById(this.projectId)
    }

    return undefined
  }

  async tagsUpdated (tags: string[]) {
    this.tagsUpdating = true

    const testPayload = { tags: tags.join(',') }
    await store.dispatch.workspace.updateTest({ test: testPayload, workspaceId: this.workspaceId, testId: this.testId })

    this.currentTags = tags

    this.tagsUpdating = false
  }
}
